import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { img } from "../../lib/api";
import { waLink } from "../../lib/site";

export const ProjectDialog = ({ project, onClose }) => {
  const p = project;
  const isShop = p?.kind === "shop";
  return (
    <Dialog open={!!p} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-lenis-prevent data-testid="project-dialog" className="max-w-5xl w-[94vw] max-h-[90vh] overflow-y-auto bg-cream border-stone p-0 rounded-none">
        {p && (
          <div className="grid lg:grid-cols-5">
            <div className="lg:col-span-3 space-y-2 p-2">
              {(p.images || []).map((u, i) => (
                <img key={u + i} src={img(u)} alt={`${p.title} ${i + 1}`} className="w-full object-cover" />
              ))}
            </div>
            <div className="lg:col-span-2 p-6 sm:p-8 lg:sticky lg:top-0 self-start">
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-terra">{p.category}</p>
              <DialogTitle className="mt-2 font-serif text-4xl font-normal text-ink leading-tight">{p.title}</DialogTitle>
              {(p.location || p.date) && <p className="mt-2 text-sm text-ash">{[p.location, p.date].filter(Boolean).join(" · ")}</p>}
              <DialogDescription className="mt-5 text-base text-ink/80 leading-relaxed whitespace-pre-line">{p.description}</DialogDescription>
              <a
                href={waLink(isShop ? `Ciao Annette, mi piacerebbe qualcosa come "${p.title}".` : `Ciao Annette, ho visto il progetto "${p.title}" e vorrei informazioni per il mio matrimonio.`)}
                target="_blank" rel="noreferrer" data-testid="project-dialog-whatsapp"
                className="mt-8 inline-flex rounded-full bg-cypress text-cream px-6 py-3 text-sm hover:bg-terra transition-colors"
              >
                {isShop ? "Ordina su WhatsApp" : "Voglio qualcosa di simile"}
              </a>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
